import React from 'react';
import { twMerge } from 'utilities/src/twMerge';

import { ILabelTopProps } from './_props';

import useInputLabelTopTheme from './themes';

/**
 * LabelTop Component
 */

function LabelTop({ id, label, labelPosition, theme, size = 'Medium', required = false }: ILabelTopProps) {
  const { labelTopThemeClasses, labelTopColorThemeClasses, labelTopOptionalThemeClasses, labelTopSizeClasses } =
    useInputLabelTopTheme({
      inputTheme: theme,
      inputSize: size,
    });

  if (!label || labelPosition !== 'Top') return null;

  return (
    <div
      id={`label-top-${id}`}
      className={twMerge('label', labelTopThemeClasses, labelTopColorThemeClasses, labelTopSizeClasses)}
    >
      {label}

      {!required && <span className={labelTopOptionalThemeClasses}> (Optional) </span>}
    </div>
  );
}

export default LabelTop;
